import { Vue, Component, Prop } from 'vue-property-decorator'
import ConfigurationRelationships from '@/modules/configurationModule/shared/components/configuration-relationships/configuration-relationships.vue'
import { ConfigurationDeviceResponse } from '@/modules/configurationModule/detail/instrumentation/devices/services/configuration-device/configuration-device.dto'
import {
    ConfigurationInstrumentationDevicesModalVisibilityFormOperationsState,
    initialConfigurationInstrumentationDevicesModalVisibilityFormOperationsState
} from '@/modules/configurationModule/detail/instrumentation/devices/components/modal-visibility-form-operations/configuration-instrumentation-devices-modal-visibility-form-operations.model'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'
import { OperationResponse } from '@/modules/configurationModule/detail/local-laboratory-module/sections/services/operation/operation.dto'
import { operationService } from '@/modules/configurationModule/detail/local-laboratory-module/sections/services/operation/operation.service'
import {
    ConfigurationDeviceOperationCreateRequest,
    ConfigurationDeviceOperationResponse
} from '@/modules/configurationModule/detail/instrumentation/devices/services/configuration-device-operation/configuration-device-operation.dto'
import { configurationDeviceOperationService } from '@/modules/configurationModule/detail/instrumentation/devices/services/configuration-device-operation/configuration-device-operation.service'
import { GridUtils } from '@/shared/util/grid-utils'

@Component({
    components: {
        ConfigurationRelationships
    }
})
export default class ConfigurationInstrumentationDevicesModalVisibilityFormOperations extends Vue {
    @Prop() readonly device!: ConfigurationDeviceResponse

    state: ConfigurationInstrumentationDevicesModalVisibilityFormOperationsState
    constructor() {
        super()
        this.state = initialConfigurationInstrumentationDevicesModalVisibilityFormOperationsState()
    }

    /// SERVICES CALLS ///

    private async _getOperations(): Promise<OperationResponse[]> {
        const params: CommonParams = {
            size: PAGINATOR_BIG_PAGE_SIZE
        }
        const response = await this.$_toCallSecureLoading(operationService.paginator(undefined, params))
        return response?.content ?? []
    }

    private async _getDeviceOperations(): Promise<ConfigurationDeviceOperationResponse[]> {
        const filterModel: CommonFilterModel = {
            'device.id': GridUtils.getNumberFilterModel('equals', this.device.id)
        }
        const params: CommonParams = {
            size: PAGINATOR_BIG_PAGE_SIZE
        }
        const response = await this.$_toCallSecureLoading(configurationDeviceOperationService.paginator(filterModel, params, this.state.laboratoryId))
        return response?.content ?? []
    }

    private async _createDeviceOperation(createRequest: ConfigurationDeviceOperationCreateRequest): Promise<ConfigurationDeviceOperationResponse | null> {
        const response = await this.$_toCallUnique(configurationDeviceOperationService.create(this.state.laboratoryId, createRequest))
        if (response) {
            this.$_showToastSuccess(this.$tc('configuration.toastMessages.created'))
            return response
        }
        return null
    }

    private async _deleteDeviceOperation(deviceOperationId: number): Promise<void | null> {
        const response = await this.$_toCallUnique(configurationDeviceOperationService.delete(this.state.laboratoryId, deviceOperationId))
        if (response !== null) {
            this.$_showToastSuccess(this.$tc('configuration.toastMessages.deleted'))
            return response
        }
        return null
    }

    ///

    private async _loadOperations(): Promise<void> {
        this.state.operations = await this._getOperations()
    }

    private async _loadDeviceOperations(): Promise<void> {
        this.state.deviceOperations = await this._getDeviceOperations()
    }

    /// HOOKS ///

    async mounted() {
        try {
            this.$_updateLoading(true)

            await Promise.all([
                this._loadOperations(),
                this._loadDeviceOperations()
            ])
        } finally {
            this.$_updateLoading(false)
        }
    }

    /// OPERATIONS ///

    async addOperation(operation: OperationResponse): Promise<void> {
        if (operation) {
            const createRequest: ConfigurationDeviceOperationCreateRequest = {
                deviceId: this.device.id,
                operationId: operation.id
            }
            if (await this._createDeviceOperation(createRequest)) {
                await this._loadDeviceOperations()
            }
        }
    }

    async deleteOperation(deviceOperation: ConfigurationDeviceOperationResponse): Promise<void> {
        if (deviceOperation) {
            if (await this._deleteDeviceOperation(deviceOperation.id) !== null) {
                await this._loadDeviceOperations()
            }
        }
    }
}
